import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import CategoryTabs from '@/components/base/CategoryTabs';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import LatestUpdates from './components/LatestUpdates';
import PopularSection from './components/PopularSection';
import CTASection from './components/CTASection';

export default function Home() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '韩漫在线阅读网提供哪些类型的韩国漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们提供恋爱、奇幻、校园、动作、悬疑、搞笑、剧情等多种类型的韩国漫画免费阅读，满足不同读者的阅读偏好。',
        },
      },
      {
        '@type': 'Question',
        name: '韩国漫画免费看的更新频率是怎样的？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的韩漫资源与韩国同步更新，大部分热门韩漫每周都会更新最新章节，确保读者第一时间获取最新连载。',
        },
      },
      {
        '@type': 'Question',
        name: '是否需要注册才能阅读韩漫全集？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '不需要！韩漫在线阅读网所有漫画资源均可免费在线阅读，无需注册或付费，打开即看，方便快捷。',
        },
      },
      {
        '@type': 'Question',
        name: '热门韩漫推荐有哪些标准？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的热门韩漫推荐基于读者阅读量、评分、讨论热度等多维度数据，结合编辑团队的专业评审，为用户推荐最优质的韩漫作品。',
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />

        <section className="py-8 bg-background-50 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-price-tag-3-line text-primary-500"></i>
              </div>
              <h2 className="font-heading text-lg text-foreground-900">
                韩漫分类
              </h2>
            </div>
            <CategoryTabs />
          </div>
        </section>

        <FeaturedSection />
        <LatestUpdates />
        <PopularSection />

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
                常见问题
              </h2>
              <p className="text-sm text-foreground-500">
                关于韩国漫画免费看的常见疑问解答
              </p>
            </div>
            <script type="application/ld+json">
              {JSON.stringify(faqSchema)}
            </script>
            <div className="space-y-3">
              {faqSchema.mainEntity.map((faq, index) => (
                <details key={index} className="group bg-background-50 rounded-lg border border-background-200/70">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                    <span className="font-medium text-foreground-800 text-sm md:text-base pr-4">
                      {faq.name}
                    </span>
                    <div className="w-5 h-5 flex items-center justify-center shrink-0">
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                    </div>
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.acceptedAnswer.text}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <CTASection />
      </main>
      <Footer />
    </>
  );
}